import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabase.js';
import { count, countValue, loadEmailCampaigns } from './adminData.js';
import { SortableTable } from './SortableTable.jsx';

const automaticNames = {
  invite_emails: 'Invitations to residents and trades',
  room_emails: 'Homes emails (room checks and applications)',
  notification_emails: 'Notification emails',
  repair_reports: 'Repair reports to landlords',
};

const automaticColumns = [
  { key: 'email', label: 'Email', value: (row) => automaticNames[row.key] || row.key, cell: (row) => automaticNames[row.key] || row.key },
  { key: 'sent', label: 'Sent', value: (row) => countValue(row.sent), first: 'desc', cell: (row) => count(row.sent) },
  { key: 'waiting', label: 'Waiting', value: (row) => countValue(row.waiting), first: 'desc', cell: (row) => count(row.waiting) },
  {
    key: 'failed',
    label: 'Failed',
    value: (row) => countValue(row.failed),
    first: 'desc',
    cell: (row) => (Number(row.failed) > 0 ? <span className="admin-status is-bad">{count(row.failed)}</span> : count(row.failed)),
  },
];

/** How many of each automatic email the site has sent, has waiting and has failed to send. Admins only (the database refuses others). */
export default function AutomaticEmails() {
  const [state, setState] = useState({ data: null, error: '' });
  const load = useCallback(async () => {
    try {
      const data = await loadEmailCampaigns(supabase);
      setState({ data: data || {}, error: '' });
    } catch (cause) {
      setState((current) => ({ data: current.data, error: cause.message || 'Could not load the automatic emails. Please try again.' }));
    }
  }, []);
  useEffect(() => { void load(); }, [load]);

  const { data, error } = state;
  if (!data && !error) return <p>Loading automatic emails…</p>;

  const refresh = <button type="button" className="button button-secondary" onClick={() => void load()}>Refresh</button>;
  if (!data) {
    return (
      <>
        <p className="mod-error" role="alert">{error}</p>
        <p>{refresh}</p>
      </>
    );
  }

  const automatic = Array.isArray(data.automatic) ? data.automatic : [];

  return (
    <>
      {error && <p className="mod-error" role="alert">{error}</p>}

      <h2 className="admin-section">Automatic emails</h2>
      {automatic.length === 0
        ? <p className="admin-empty">No automatic emails have been recorded yet.</p>
        : (
          <SortableTable columns={automaticColumns} rows={automatic} rowKey={(row) => row.key}/>
        )}
    </>
  );
}
